export function GetParallelLine(pole1, pole2, pomeraj) {

    let lat1 = pole1.lat;
    let lng1 = pole1.lng;
    let lat2 = pole2.lat;
    let lng2 = pole2.lng

    let r = pomeraj / Math.hypot(lat2 - lat1, lng2 - lng1);
    let vx = (lat2 - lat1) * r;
    let vy = (lng2 - lng1) * r;

    let parallelLine = [{ lat: lat1 - vy, lng: lng1 + vx }, { lat: lat2 - vy, lng: lng2 + vx }];
    return parallelLine;
}

export function GetParallelLines(poleList, spanList, pomeraj) {

    let parallelLine = [];

    for (let i = 0; i < poleList.length - 1; i++) {
        let lat1 = poleList[i].lat;
        let lng1 = poleList[i].lng;
        let lat2 = poleList[i + 1].lat;
        let lng2 = poleList[i + 1].lng

        let r = pomeraj / Math.hypot(lat2 - lat1, lng2 - lng1);
        let vx = (lat2 - lat1) * r;
        let vy = (lng2 - lng1) * r;


        if (spanList[i] && poleList[i]) {
            parallelLine.push({
                poleName: poleList[i].name,
                spanName: spanList[i].name,
                path: [{ lat: lat1 - vy, lng: lng1 + vx }, { lat: lat2 - vy, lng: lng2 + vx }]
            });
        }
    }

    return parallelLine;
}


export function FindCenter(location1, location2) {

    let mediumLat;
    let mediumLng;
    if (location1 && location2 && location1.lat && location1.lng && location2.lat && location2.lng) {

        let lat1 = location1.lat;
        let lat2 = location2.lat;
        let lng1 = location1.lng;
        let lng2 = location2.lng;

        mediumLat = Math.min(lat1, lat2) + Math.abs((lat1 - lat2)) / 2;
        mediumLng = Math.min(lng1, lng2) + Math.abs((lng1 - lng2)) / 2;
    }

    return { lat: mediumLat, lng: mediumLng }
}


export function GetOhlSegments(ohlsList, poleList, ohlName) {

    //debugger;
    let resultList = [];
    let segmentList = [];
    let ohls = [ohlName];

    if (poleList && poleList.length > 1) {
        let isSegmentDivided = poleList[0].sys < 2 ? false : true;

        for (let i = 0; i < poleList.length; i++) {

            const isCurrentPoleDivided = poleList[i].sys < 2 ? false : true;
            segmentList.push(poleList[i]);

            if (isSegmentDivided) {
                for (let l = 0; l < ohlsList.length; l++) {
                    let poles = ohlsList[l].stubovi;
                    for (let k = 0; k < poles.length; k++) {
                        if (poleList[i].lat === poles[k].lat && poleList[i].lng === poles[k].lng) {
                            if (!ohls.includes(ohlsList[l].name)) {
                                ohls.push(ohlsList[l].name);
                            }
                        }
                    }
                }
            }

            if (isSegmentDivided !== isCurrentPoleDivided || (isCurrentPoleDivided && i + 1 < poleList.length && poleList[i + 1].sys < 2)) {

                resultList.push({ path: segmentList, isDivided: isSegmentDivided, OHLs: ohls });
                segmentList = [];
                ohls = [];
                ohls.push(ohlName);
                segmentList.push(poleList[i])
                isSegmentDivided = !isSegmentDivided;
            }
        }

        resultList.push({ path: segmentList, isDivided: isSegmentDivided, OHLs: ohls });
    }

    return resultList;
}


export function FilterSpans(spansList, bounds) {
    return spansList.filter(span =>
        span.position[0].lat >= bounds.latMin
        && span.position[1].lat >= bounds.latMin
        && span.position[0].lat <= bounds.latMax
        && span.position[1].lat <= bounds.latMax
        && span.position[0].lng >= bounds.lngMin
        && span.position[1].lng >= bounds.lngMin
        && span.position[0].lng <= bounds.lngMax
        && span.position[1].lng <= bounds.lngMax
    );
}


export function GetDividedSpans(ohlsList, poleList, spanList, position, phaseCrossList, ohlName) {

    let resultList = [];
    let pomerajRaspona = -0.0001;

    if (position === 'N') {
        pomerajRaspona = 0.0001;
    }

    let ohlSegments = GetOhlSegments(ohlsList, poleList, ohlName);

    ohlSegments.filter(ohlSegment => ohlSegment.isDivided === false).forEach(poles => {
        for (let i = 0; i < poles.path.length - 1; i++) {

            let path = poles.path[i];
            let pole = poleList.filter(pole => pole.lat === path.lat && pole.lng === path.lng)[0];
            let path2 = poles.path[i + 1];
            let pole2 = poleList.filter(pole => pole.lat === path2.lat && pole.lng === path2.lng)[0];

            let spanName = pole.name + ' - ' + poles.path[i + 1].name
            let span = spanList.filter(span => span.name === spanName)[0];
            //let span = spanList.find(span => span.position[0].lat === pole.lat && span.position[0].lng === pole.lng);

            if (i === poles.path.length - 2 && pole2.sys > 1) {
                let path1 = poles.path[i];
                let path2 = poles.path[i + 1];

                let position = /*this.getParallelLine*/ GetParallelLine(path1, path2, pomerajRaspona);
                if (position && span) {
                    span.position[1] = position[1];
                }
            }

            if (i === 0 && pole.sys > 1) {

                let path1 = poles.path[i];
                let path2 = poles.path[i + 1];
                let position = /*this.getParallelLine*/ GetParallelLine(path1, path2, pomerajRaspona);
                if (position && span) {
                    span.position[0] = position[0];
                    span.position[1] = path2;
                }
            }

            if (span) {
                let spanNew = {
                    name: span.name,
                    position: span.position,
                    isPhaseCross: IsSpanWithPhaseCross(span.name, phaseCrossList)
                }
                resultList.push(spanNew);
            }
        }
    });


    ohlSegments.filter(ohlSegment => ohlSegment.isDivided).forEach(poles => {
        for (let i = 0; i < poles.path.length - 1; i++) {

            let path = poles.path[i];
            let pole = poleList.filter(pole => pole.lat === path.lat && pole.lng === path.lng)[0];
            let spanName = pole.name + ' - ' + poles.path[i + 1].name
            let span = spanList.filter(span => span.name === spanName)[0];

            let position = GetParallelLine(poles.path[i], poles.path[i + 1], pomerajRaspona);
            if (span) {
                let spanNew = { name: span.name, position: position, isPhaseCross: IsSpanWithPhaseCross(span.Name, phaseCrossList) };
                resultList.push(spanNew);
            }
        }
    });

    return resultList;
}


export function GetPhasesLocations(spansList, phaseCrossList, phases = [{ name: 0, positionIPS: 'Left', position: 'S' }, { name: 4, positionIPS: 'Middle', position: null }, { name: 8, positionIPS: 'Right', position: 'N' }]) {

    let resultList = [];
    if (phases) {

        phases.forEach(phase => {
            const phaseName = phase.name;
            let position = phase.position;
            let ipsPosition = phase.positionIPS;
            let phasePosition;
            const pomerajFaza = 0.00005;
            let pomeraj = GetPomeraj(position, pomerajFaza)

            spansList.forEach(span => {

                if (pomeraj) {
                    phasePosition = GetParallelLine(span.position[0], span.position[1], pomeraj)
                }
                else {
                    phasePosition = span.position
                }

                if (phaseCrossList) {
                    phaseCrossList.forEach(pc => {
                        if (pc.name === span.name) {

                            let positionIpsNew = pc.phases.filter(p => p.phase === phaseName)[0].position2;
                            let positionNew = phases.filter(p => p.positionIPS === positionIpsNew);
                            let newPhasePosition;

                            if (positionNew) {
                                position = positionNew[0].position;
                                ipsPosition = positionNew[0].positionIPS;
                            }

                            pomeraj = GetPomeraj(position, pomerajFaza);

                            if (pomeraj) {
                                newPhasePosition = GetParallelLine(span.position[0], span.position[1], pomeraj)
                            }
                            else {
                                newPhasePosition = span.position
                            }

                            phasePosition = [phasePosition[0], newPhasePosition[1]];
                        }
                    })

                }
                let spanPhase = {
                    phase: phaseName,
                    path: phasePosition,
                    position: ipsPosition,
                    spanName: span.name
                }
                resultList.push(spanPhase)
            })
        })
    }

    return resultList;
}


export function GetPomeraj(pomeraj, value) {
    let result;
    switch (pomeraj) {
        case 'N': result = Math.abs(value);
            break;
        case 'S': result = -Math.abs(value);
            break
        default: result = null;
            break;
    }

    return result;
}


export function IsSpanWithPhaseCross (spanName, phaseCrossList) {
    if(phaseCrossList){
        return phaseCrossList.filter(pc => pc.name === spanName).length === 0 ? false : true;
    }
    return false;
}

// export function FindOhlOrienation = (ohlName) => {

//     let position = 'S';
//     let ohl = this.props.ohlList.find(ohl => ohl.name === ohlName);

//     if(ohl){
//         let poleA = ohl.stubovi.find(pole => pole.index === 1);
//         let poleB = ohl.stubovi.find(pole => pole.index !== 1 && pole.portal);

//         if(poleA && poleB && ohl.positionOnPoles){

//             let poleAPosition = poleA.lat + poleA.lng;
//             let poleBPosition = poleB.lat + poleB.lng;

//             if((poleBPosition < poleAPosition && ohl.positionOnPoles === 'Right') || (poleBPosition > poleAPosition && ohl.positionOnPoles === 'Left')) position = 'N';
//         }
//     }
// }